import GeneratedLoginServiceApi from "./generated/GeneratedLoginServiceApi"

class LoginServiceApi extends GeneratedLoginServiceApi {

}

export const loginServiceApi = new LoginServiceApi()
